//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uploadPicture from '@/components/uploadPicture/index';
export default {
  name: 'Attach',
  components: {
    uploadPicture: uploadPicture
  },
  data: function data() {
    return {};
  },
  computed: {},
  mounted: function mounted() {},
  methods: {}
};